export const maxPerPage = 900719925 // Number.MAX_SAFE_INTEGER is not working, server throws 500
